import { render, staticRenderFns } from "./TabDetail.vue?vue&type=template&id=33b6ce94&scoped=true&"
import script from "./TabDetail.vue?vue&type=script&lang=js&"
export * from "./TabDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6ce94",
  null
  
)

export default component.exports